import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';
import TopNavbarre from '../composants/topnavbarre';
import Footer from '../composants/footer';
import { FaGlobe, FaGraduationCap, FaUsers, FaRocket, FaMapMarkerAlt, FaCheckCircle, FaStar, FaGlobeAfrica, FaUserGraduate, FaQuoteLeft } from "react-icons/fa";
import header from '../asset/5.png';
import apropos1 from '../asset/apropos_1.jpeg';
import apropos2 from '../asset/apropos_2.jpg';
// import { Helmet } from 'react-helmet-async'; // SUPPRIMÉ

const Home = () => {
  //Le referencement sur les moteurs de recherche
  useEffect(() => {
    document.title = "France Études | Étudier à l'étranger, orientation et mobilité internationale";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "France Études accompagne les étudiants dans leurs projets d'études à l'international : orientation, admission, bourses, mobilité et réussite académique.");
    } else {
      const meta = document.createElement('meta');
      meta.name = "description";
      meta.content = "France Études accompagne les étudiants dans leurs projets d'études à l'international : orientation, admission, bourses, mobilité et réussite académique.";
      document.head.appendChild(meta);
    }
  }, []);

  const handleScroll = (e) => {
    e.preventDefault();
    const nextSection = document.getElementById('content');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Les données pour les statistiques
  const stats = [
    { value: "+100", label: "Étudiants accompagnés", description: "Vers les meilleures universités" },
    { value: "+10", label: "Événements organisés", description: "Workshops et séances d'information" },
    { value: "100%", label: "Taux de réussite", description: "Dans nos programmes d'accompagnement" },
  ];

  // La mission des données
  const missions = [
    {
      icon: <FaGraduationCap className="text-3xl" />,
      title: "Accompagnement personnalisé",
      description: "Offrir un suivi sur mesure aux étudiants dans toutes les étapes de leur projet d'étude à l'étranger.",
      color: "bg-blue-100 text-blue-600"
    },
    {
      icon: <FaGlobe className="text-3xl" />,
      title: "Mobilité internationale",
      description: "Faciliter l'accès à l'éducation à l'étranger grâce à notre réseau de partenaires internationaux.",
      color: "bg-purple-100 text-purple-600"
    },
    {
      icon: <FaUsers className="text-3xl" />,
      title: "Sensibilisation & orientation",
      description: "Informer les jeunes sur les opportunités d'études et de bourses à travers des séances de sensibilisation.",
      color: "bg-green-100 text-green-600"
    },
    {
      icon: <FaRocket className="text-3xl" />,
      title: "Réussite et insertion",
      description: "Aider chaque étudiant à réussir son parcours et s'intégrer dans un nouvel environnement académique.",
      color: "bg-orange-100 text-orange-600"
    },
  ];

  // Destinations des données
  const destinations = [
    { name: "France", flag: "🇫🇷", universities: 50 },
    { name: "Russie", flag: "🇷🇺", universities: 15 },
    { name: "Sénégal", flag: "🇸🇳", universities: 8 },
    { name: "Turquie", flag: "🇹🇷", universities: 12 },
    { name: "Maroc", flag: "🇲🇦", universities: 10 },
    { name: "Belgique", flag: "🇧🇪", universities: 20 }
  ];

  const boursePays = [
    { name: "Canada", flag: "🇨🇦", scholarship: "Bourse Excellence+" },
    { name: "États-Unis", flag: "🇺🇸", scholarship: "Fulbright Program" },
    { name: "Brésil", flag: "🇧🇷", scholarship: "Science sans Frontières" },
    { name: "Mexique", flag: "🇲🇽", scholarship: "Becas CONACYT" }
  ];

  // Les données de la section pourquoi nous choisir
  const raisons = [
    {
      icon: <FaUserGraduate className="text-3xl" />,
      titre: "Expertise éducative",
      texte: "Nous maîtrisons les systèmes éducatifs étrangers et adaptons votre projet d'étude selon votre profil.",
      color: "bg-blue-100 text-blue-600"
    },
    {
      icon: <FaGlobeAfrica className="text-3xl" />,
      titre: "Réseau international",
      texte: "Des partenariats avec plusieurs établissements dans différents pays pour faciliter votre admission.",
      color: "bg-purple-100 text-purple-600"
    },
    {
      icon: <FaCheckCircle className="text-3xl" />,
      titre: "Suivi personnalisé",
      texte: "Un accompagnement à chaque étape : dossier, visa, logement, intégration.",
      color: "bg-green-100 text-green-600"
    },
    {
      icon: <FaStar className="text-3xl" />,
      titre: "Taux de satisfaction élevé",
      texte: "Des centaines d'étudiants accompagnés avec succès et recommandent nos services.",
      color: "bg-orange-100 text-orange-600"
    },
  ];

  const temoignages = [
    {
      nom: "KOUMBA.",
      texte: "Je tiens à exprimer ma sincère gratitude à LMK Travel et France Études pour leur accompagnement précieux. Grâce à leur soutien, j'ai pu obtenir une acceptation à Campus France. ",
      pays: "🇫🇷 France",
      note: 5
    },
    {
      nom: "MABIALA Grace.",
      texte: "J'ai eu une bourse pour étudier au Canada, c'est une vraie bénédiction d'avoir connu cette agence !",
      pays: "🇨🇦 Canada",
      note: 4
    },
    {
      nom: "OLENDA Jacquie.",
      texte: "Le service client est très réactif, j'ai reçu mon admission en Turquie avec leur aide. Merci encore !",
      pays: "🇹🇷 Turquie",
      note: 4
    },
  ];

  // Animation variants pour les stats
  const statsContainer = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const statsItem = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  // Animation variants pour les missions
  const missionsContainer = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const missionsItem = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  // Animation variants pour les destinations
  const destinationsContainer = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const destinationsItem = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  // Animation variants pour les raisons et témoignages
  const raisonsContainer = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const raisonsItem = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <div>
      {/* <Helmet>
        <title>France Études | Étudier à l'étranger, orientation et mobilité internationale</title>
        <meta name="description" content="France Études accompagne les étudiants dans leurs projets d'études à l'international : orientation, admission, bourses, mobilité et réussite académique." />
        <meta name="keywords" content="études à l'étranger, orientation, mobilité internationale, bourse, admission, université, France Études, accompagnement étudiant" />
        <link rel="canonical" href="https://www.lmktravel.com/" />
      </Helmet> */}
      <section className="relative bg-cover bg-center h-screen flex flex-col">
        {/* Image de fond avec overlay */}
        <div 
          className="absolute inset-0 bg-black/30 bg-blend-darken"
          style={{
            backgroundImage: `url(${header})`,
            backgroundPosition: 'center -20%', // Modification pour ramener l'image un peu en bas
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>
        
        {/* Navbar */}
        <TopNavbarre/>
        
        {/* Contenu principal centré verticalement et horizontalement */}
        <div className="relative z-10 flex-grow flex flex-col items-center justify-center text-center">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl lg:max-w-4xl">
              {/* Titre principal avec animation */}
              <motion.h1 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="text-2xl sm:text-2xl md:text-2xl lg:text-3xl font-bold text-white leading-tight mb-2 sm:mb-4 text-center"
              >
                Étudiez à l'étranger avec <span className="text-blue-400">France Études</span>
              </motion.h1>
              
              {/* Sous-titre */}
              <motion.p 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8 }}
                className="text-base sm:text-lg md:text-xl text-gray-100 mb-6 sm:mb-8 max-w-lg text-center"
              >
                Notre expertise pour concrétiser votre projet d'études internationales
              </motion.p>
              
              {/* Groupe de boutons - Taille réduite sur mobile */}
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.8 }}
                className="flex flex-col sm:flex-row gap-3 sm:gap-4"
              >
                <Link
                  to="#destinations"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold 
                            px-4 py-2 sm:px-6 sm:py-2.5 md:px-8 md:py-3 
                            rounded-lg shadow-lg transition-all duration-300 
                            transform hover:-translate-y-1 text-sm sm:text-base mx-auto block text-center"
                  onClick={(e) => {
                    e.preventDefault();
                    const destinationsSection = document.getElementById('destinations');
                    if (destinationsSection) {
                      destinationsSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  Découvrir nos destinations
                </Link>
              </motion.div>
            </div>
          </div>
        </div>
        
        {/* Indicateur de défilement - Taille réduite sur mobile */}
        <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <motion.a 
            href="#content" 
            className="animate-bounce inline-block"
            onClick={handleScroll}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </motion.a>
        </div>
      </section>

      {/* Section suivante avec l'ID content */}
      <section id="content" className="bg-gradient-to-br from-pink-50 to-blue-50 py-12 md:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 xl:gap-16">
            {/* Images - avec animations */}
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="w-full lg:w-1/2 flex justify-center relative"
            >
              <div className="relative w-full max-w-md">
                <div className="aspect-w-4 aspect-h-3 rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={apropos1}
                    alt="Équipe France Études"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="hidden lg:block absolute -bottom-6 -right-6 w-1/3 h-1/3">
                  <div className="aspect-square rounded-xl overflow-hidden shadow-xl border-4 border-white transform rotate-3">
                    <img
                      src={apropos2}
                      alt="Fondateur France Études"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Texte - avec animations */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="w-full lg:w-1/2 space-y-6 px-4"
            >
              {/* Badge */}
              <div className="inline-block bg-blue-100 rounded-full px-4 py-1 mb-4">
                <span className="text-blue-700 font-medium text-sm">À propos de nous</span>
              </div>

              {/* Titre */}
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
                Votre réussite internationale <span className="text-blue-600">commence ici</span>
              </h2>

              {/* Texte */}
              <div className="space-y-4 text-gray-700">
                <p className="text-base md:text-lg leading-relaxed text-justify"> 
                  France Études est un cabinet d'orientation scolaire spécialisé dans la mobilité internationale. 
                  Nous accompagnons les étudiants ambitieux dans la réalisation de leur projet d'études à l'étranger.
                </p>

                <p className="text-base md:text-lg leading-relaxed text-justify">
                  Fondé par des passionnés ayant eux-mêmes surmonté des défis pour accéder à l'éducation, 
                  nous comprenons les obstacles et savons comment les transformer en opportunités.
                </p>
              </div>

              {/* Bouton */}
              <div className="pt-2">
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Link
                    to="/formations"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium 
                              shadow-md transition-all duration-300 text-center inline-block"
                  >
                    Nos formations
                  </Link>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section des statistiques */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <motion.div 
            initial="hidden"
            whileInView="show"
            variants={statsContainer}
            viewport={{ once: true, margin: "-100px" }}
            className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 lg:gap-8 xl:gap-12"
          >
            {stats.map((stat, index) => (
              <motion.div 
                key={index} 
                variants={statsItem}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 text-white">
                    {stat.value}
                  </h3>
                  <p className="text-lg sm:text-xl font-semibold mb-2 text-white">
                    {stat.label}
                  </p>
                  <p className="text-sm sm:text-base text-blue-100">
                    {stat.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </motion.div>

          {/* Call-to-action */}
          <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          viewport={{ once: true }}
          className="mt-16 text-center md:mt-0" // Ajout de md:mt-0 pour annuler la marge sur les écrans moyens et grands
        >
          <Link to="/communaute" className="text-white/80 mb-4 text-sm md:text-base block">
            Rejoignez notre communauté d'étudiants internationaux
          </Link>
          <Link 
            to="/contact" 
            className="bg-white text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-lg font-medium shadow-md transition-all duration-300 mt-4 md:mt-0"
          >
            Contactez-nous
          </Link>
        </motion.div>
        </div>
      </section>

      {/* Section des missions */}
      <section className="bg-gradient-to-b from-white to-gray-50 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <span className="inline-block bg-blue-100 text-blue-600 px-4 py-1 rounded-full text-sm font-medium mb-4">
              Notre engagement
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Nos <span className="text-blue-600">Missions</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Chez France Études, nous nous engageons à accompagner les étudiants vers l'excellence académique à l'international.
            </p>
          </motion.div>

          {/* Mission Cards */}
          <motion.div 
            initial="hidden"
            whileInView="show"
            variants={missionsContainer}
            viewport={{ once: true, margin: "-100px" }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
          >
            {missions.map((mission, index) => (
              <motion.div 
                key={index} 
                variants={missionsItem}
                whileHover={{ y: -10 }}
                className="group"
              >
                <div className="h-full bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 group-hover:shadow-lg transition-all duration-300">
                  <div className={`p-6 flex flex-col items-center text-center h-full`}>
                    <div className={`${mission.color} w-16 h-16 rounded-full flex items-center justify-center mb-6`}>
                      {mission.icon}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{mission.title}</h3>
                    <p className="text-gray-600 mb-6 flex-grow">{mission.description}</p>
                    <div className="w-10 h-1 bg-blue-600 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          {/* Additional CTA */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            viewport={{ once: true }}
            className="mt-20 text-center"
          >
            <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 md:p-10 shadow-xl">
              <div className="max-w-4xl mx-auto">
                <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                  <div className="text-left">
                    <h3 className="text-2xl font-bold text-white mb-2">Prêt à commencer votre aventure internationale ?</h3>
                    <p className="text-blue-100">Notre équipe est à votre disposition pour vous guider.</p>
                  </div>
                  <Link 
                    to="/contact" 
                    className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold shadow-md transition-all duration-300 whitespace-nowrap"
                  >
                    Prendre rendez-vous
                  </Link>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Section des destinations */}
      <section id="destinations" className="bg-gradient-to-b from-gray-50 to-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <div className="inline-flex items-center justify-center bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-medium mb-4">
              <FaMapMarkerAlt className="mr-2" />
              Nos destinations
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Étudiez dans les <span className="text-blue-600">meilleures universités</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Nous vous accompagnons dans plus de 10 pays à travers le monde avec notre réseau de partenaires universitaires.
            </p>
          </motion.div>

          {/* Main Destinations */}
          <motion.div 
            initial="hidden"
            whileInView="show"
            variants={destinationsContainer}
            viewport={{ once: true, margin: "-100px" }}
            className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 mb-16"
          >
            {destinations.map((pays, index) => (
              <motion.div 
                key={index} 
                variants={destinationsItem}
                whileHover={{ y: -5 }}
                className="group"
              >
                <div className="h-full bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center group-hover:shadow-md group-hover:border-blue-100 transition-all duration-300">
                  <div className="text-4xl mb-3">{pays.flag}</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{pays.name}</h3>
                  <p className="text-sm text-gray-500">{pays.universities}+ universités</p>
                </div>
              </motion.div>
            ))}
          </motion.div>

          {/* Scholarship Destinations */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 md:p-10 mb-12"
          >
            <div className="max-w-4xl mx-auto text-center">
              <div className="inline-flex items-center justify-center bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
                <FaGraduationCap className="mr-2" />
                Opportunités de bourses
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-6">
                Pays avec programmes de bourses
              </h3>
              <p className="text-blue-100 mb-8 max-w-3xl mx-auto">
                Nous vous aidons à obtenir des bourses d'études dans ces pays partenaires.
              </p>

              <motion.div 
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
                variants={destinationsContainer}
              >
                {boursePays.map((pays, index) => (
                  <motion.div 
                    key={index}
                    variants={destinationsItem}
                    whileHover={{ scale: 1.03 }}
                    className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20 hover:bg-white/20 transition-all duration-300"
                  >
                    <div className="text-3xl mb-2">{pays.flag}</div>
                    <h4 className="text-lg font-semibold text-white mb-1">{pays.name}</h4>
                    <p className="text-sm text-blue-100">{pays.scholarship}</p>
                  </motion.div>
                ))}
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Section Pourquoi nous choisir et Témoignages */}
      <section className="bg-gradient-to-b from-white to-gray-50 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Pourquoi nous choisir */}
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mb-20"
          >
            <div className="text-center mb-16">
              <span className="inline-block bg-gradient-to-r from-blue-600 to-blue-800 text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
                Notre valeur ajoutée
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Pourquoi choisir <span className="text-blue-600">France Études</span> ?
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Découvrez ce qui fait notre différence et pourquoi des centaines d'étudiants nous font confiance chaque année.
              </p>
            </div>

            <motion.div 
              initial="hidden"
              whileInView="show"
              variants={raisonsContainer}
              viewport={{ once: true, margin: "-100px" }}
              className="grid grid-cols-1 lg:grid-cols-2 gap-8"
            >
              {raisons.map((raison, index) => (
                <motion.div 
                  key={index} 
                  variants={raisonsItem}
                  whileHover={{ scale: 1.02 }}
                  className="group"
                >
                  <div className="h-full bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg overflow-hidden border border-gray-100 group-hover:shadow-xl transition-all duration-300">
                    <div className="p-8 flex items-start space-x-6">
                      <div className={`${raison.color} w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 transform group-hover:rotate-6 transition-transform duration-300`}>
                        {raison.icon}
                      </div>
                      <div className="flex-grow">
                        <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-300">{raison.titre}</h3>
                        <p className="text-gray-600 leading-relaxed">{raison.texte}</p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </motion.div>

          {/* Section Témoignages */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            viewport={{ once: true }}
            className="mt-32"
          >
            <div className="text-center mb-16">
              <span className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-medium mb-4">
                Ils nous font confiance
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Témoignages <span className="text-blue-600">d'étudiants</span>
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Découvrez les retours d'expérience de nos étudiants à l'international.
              </p>
            </div>

            <motion.div 
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
              variants={raisonsContainer}
            >
              {temoignages.map((temoin, index) => (
                <motion.div 
                  key={index}
                  variants={raisonsItem}
                  whileHover={{ scale: 1.02 }}
                  className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden"
                >
                  <div className="p-8 h-full flex flex-col">
                    <div className="mb-6 text-blue-400">
                      <FaQuoteLeft className="text-3xl opacity-30" />
                    </div>
                    <p className="text-gray-700 mb-6 flex-grow italic">"{temoin.texte}"</p>
                    <div className="border-t border-gray-100 pt-6">
                      <div className="flex justify-between items-center">
                        <div>
                          <h4 className="font-bold text-gray-900">{temoin.nom}</h4>
                          <p className="text-sm text-gray-500">{temoin.pays}</p>
                        </div>
                        <div className="flex items-center">
                          {[...Array(5)].map((_, i) => (
                            <FaStar 
                              key={i} 
                              className={`${i < temoin.note ? 'text-yellow-400' : 'text-gray-300'} ml-1`} 
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>

            {/* CTA */}
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
              viewport={{ once: true }}
              className="mt-20 text-center"
            >
              <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 md:p-10 shadow-xl">
                <div className="max-w-4xl mx-auto">
                  <h3 className="text-2xl font-bold text-white mb-4">Prêt à concrétiser votre projet d'études ?</h3>
                  <p className="text-blue-100 mb-6">Rejoignez nos étudiants satisfaits dès aujourd'hui.</p>
                  <Link 
                    to="/contact" 
                    className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold shadow-md transition-all duration-300"
                  >
                    Contactez un conseiller
                  </Link>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default Home;